
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/general-waste-disposal",
      function () {
        return require("private-next-pages/general-waste-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/general-waste-disposal"])
      });
    }
  